import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-upload-document-customer',
    templateUrl: './upload-document-customer.component.html',
    styleUrls: ['./upload-document-customer.component.scss'],
    standalone: false
})
export class UploadDocumentCustomerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
